import type { Language } from '../types/i18n'
import { contact } from './cv'

export type SocialPlatform = 'instagram' | 'linkedin'

export type SocialPost = {
  id: string
  platform: SocialPlatform
  image: string
  url: string
  date: string
}

export const socialProfiles: Record<SocialPlatform, { label: string; url: string }> = {
  instagram: { label: contact.instagram.label, url: contact.instagram.url },
  linkedin: { label: contact.linkedin.label, url: contact.linkedin.url },
}

export const socialPosts: SocialPost[] = [
  {
    id: 'post-suit-standing',
    platform: 'instagram',
    image:
      'https://cdn.magicpatterns.com/uploads/eUGzWpPAJwg9vBrTU5KJNw/WhatsApp_Image_2026-08-10_at_20.26.47.jpg',
    url: contact.instagram.url,
    date: '2026-07-28',
  },
  {
    id: 'post-stool',
    platform: 'instagram',
    image:
      'https://cdn.magicpatterns.com/uploads/hTZt7AisdKCNSVAvRw6C5Z/WhatsApp_Image_2026-08-10_at_20.28.58_(1).jpg',
    url: contact.instagram.url,
    date: '2026-06-14',
  },
  {
    id: 'post-dutch',
    platform: 'linkedin',
    image: 'https://cdn.magicpatterns.com/uploads/3tav964wcB1aRma4QYgSSL/1785269025433.jpg',
    url: 'https://lnkd.in/p/e5BQnQXB',
    date: '2026-08-05',
  },
]

export const socialText: Record<Language, Record<string, string>> = {
  nl: {
    'post-suit-standing': 'Nieuwe casting foto’s uit de studio — klaar voor het auditieseizoen.',
    'post-stool': 'Backstage tijdens de shoot: zwart pak, scherpe lijnen.',
    'post-dutch':
      'Eindpresentatie van Lucia Marthas met als thema DUTCH — naast performen mocht ik voor het eerst choreograferen voor recreatiegroepen 3, 4 en 5.',
  },
  en: {
    'post-suit-standing': 'New casting photos from the studio — ready for audition season.',
    'post-stool': 'Backstage on the shoot: black suit, sharp lines.',
    'post-dutch':
      'The Lucia Marthas showcase themed DUTCH — alongside performing, I choreographed for recreation groups 3, 4 and 5 for the first time.',
  },
  de: {
    'post-suit-standing': 'Neue Casting-Fotos aus dem Studio — bereit für die Vorsprechsaison.',
    'post-stool': 'Backstage beim Shooting: schwarzer Anzug, klare Linien.',
    'post-dutch':
      'Abschlusspräsentation von Lucia Marthas zum Thema DUTCH — neben dem Auftritt habe ich erstmals für die Freizeitgruppen 3, 4 und 5 choreografiert.',
  },
  fr: {
    'post-suit-standing': 'Nouvelles photos de casting en studio — prête pour la saison des auditions.',
    'post-stool': 'En coulisses du shooting : costume noir, lignes nettes.',
    'post-dutch':
      'Spectacle annuel de Lucia Marthas sur le thème DUTCH — en plus de danser, j’ai signé pour la première fois les chorégraphies des groupes loisirs 3, 4 et 5.',
  },
  es: {
    'post-suit-standing': 'Nuevas fotos de casting en estudio — lista para la temporada de audiciones.',
    'post-stool': 'Detrás de cámaras en la sesión: traje negro, líneas limpias.',
    'post-dutch':
      'Presentación anual de Lucia Marthas con el tema DUTCH — además de actuar, coreografié por primera vez para los grupos de recreación 3, 4 y 5.',
  },
}
